import { call, put, takeLatest, select } from 'redux-saga/effects';

import SDK from 'utils/sdk';
import { messageError } from 'views/ui/toast-message';
import { getMeItem } from 'modules/me/selectors';
import { SubmissionError } from 'redux-form';
import { retrieveMe } from './actions';

export function* retrieveMeSaga() {
  try {
    yield put(retrieveMe.request());
    const { id } = yield select(getMeItem);
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'me'], { id });
    yield put(retrieveMe.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(retrieveMe.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(retrieveMe.fulfill());
  }
}

export default function* meWatcher() {
  yield takeLatest(retrieveMe.TRIGGER, retrieveMeSaga);
}
